export function apiPolling(
  callback: Function,
  interval: number = 1000
): number {
  callback();
  const intervalId = setInterval(callback, interval);
  return intervalId;
}
